module.exports = __webpack_public_path__ + "static/media/1007011.8efc8a29.jpg";